import { Box, Flex, Icon, Text, Tooltip } from '@driftt/dds'
import { faQuoteRight } from '@driftt/dds.icons/solid/faQuoteRight'
import React from 'react'
import sanitizeHtml from 'sanitize-html'

const StaticInput = ({
  value,
  placeholder,
  disabled,
  onClick = () => {},
  size = 'medium',
  tooltipCaption,
  quoted = false,
}: {
  value?: string
  placeholder?: string
  disabled?: boolean
  onClick?: () => void
  size?: 'small' | 'medium'
  tooltipCaption?: string
  quoted?: boolean
}) => {
  const boxConditionalStyle = disabled
    ? {
        cursor: 'not-allowed',
      }
    : {
        cursor: 'pointer',
        '&:hover': {
          backgroundColor: '$blue1',
        },
      }

  const textConditionalStyle: { color?: string } = {}
  if (disabled) {
    textConditionalStyle.color = '$gray8'
  }
  if (!value) {
    textConditionalStyle.color = '$gray6'
  }
  const sanitizeOptions = {
    allowedTags: ['a'],
    allowedAttributes: { a: ['href'] },
  }
  const sanitizedContent = (content: string) => ({
    __html: sanitizeHtml(content, sanitizeOptions),
  })

  const onAction = disabled ? () => {} : onClick
  return (
    <Tooltip content={tooltipCaption}>
      <Box
        onClick={onAction}
        css={{
          textAlign: 'left',
          width: '100%',
          marginTop: '$1',
          padding: size === 'small' ? '4px 12px' : '12px',
          borderLeft: 'solid 2px $gray10',
          backgroundColor: '$white',
          ...boxConditionalStyle,
        }}
      >
        <Flex direction="row">
          {quoted && !!value && (
            <Icon
              icon={faQuoteRight}
              color="gray4"
              css={{ marginTop: '3px' }}
            />
          )}
          <Text
            css={{ whiteSpace: 'pre-line', ...textConditionalStyle }}
            {...(value || placeholder
              ? {
                  dangerouslySetInnerHTML: sanitizedContent(
                    value || placeholder || ''
                  ),
                }
              : {})}
          />
        </Flex>
      </Box>
    </Tooltip>
  )
}

export default StaticInput
